import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { ProfilesView } from "@/features/profiles/profiles-view";

/**
 * §M1 · `/profiles` — "Mis perfiles". No feature gate: it's the screen that
 * EXPLAINS the gates, so it can't be behind one.
 */
export const profilesRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/profiles",
  component: ProfilesView,
});
